import { createClient } from "@smfa/utils";
const baseUrl = process.env?.API_URL || process.env?.REACT_APP_BACKEND_URL;
const axios = createClient({ baseUrl, isAdminSite: true });

export const getWidget = (data) =>
  axios.get(`/widgets`, data ? { params: data } : {});

export const addWidgetdata = (data) => axios.post("/widget", data);
